/** `normalizedSource` of the automated NEW tag that Hit adds to a card's tags. */
export const NEW_TAG_SOURCE = 'promo-new';
